import React, { useState, useCallback } from 'react';
import { CalendarEvent } from './utils/eventUtils';
import { EventColorSet } from './utils/eventColors';
import { PlanApplicationModal } from './components/PlanApplicationModal';
import { useMediaQuery } from 'react-responsive';
import { PageWrapper } from 'components/PageWrapper';
import { colors } from 'assets/styled/tokens';
import { MobileNavbar } from 'components';
import { NewMenu } from 'components/Menu/NewMenu';
import { HeaderFiltersPage } from 'containers/HeaderFiltersPage';
import { AgendaContainer, KnowMoreLink, PageContent, PageContentHeader } from './styled';
import { Breadcrumbs } from 'newComponents/Navigation/Breadcrumbs';
import { Calendar } from './components/Calendar';
import { AgendaMobileLayout } from './components/Calendar/components/AgendaMobileLayout';
import { ReactComponent as OpenIcon } from 'assets/icons/open-icon-gray.svg';
import { FilterExecutorModal } from './components/FilterExecutorModal';
import { EnvironmentsEquipmentModal } from './components/EnvironmentsEquipmentModal';
import { PlanosModal } from './components/PlanosModal';
import { useAgendaMobile } from './hooks/useAgendaMobile';
import { medias } from 'assets/styled/tokens';

export const Agenda: React.FC = () => {
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState<CalendarEvent | null>(null);
  const [selectedColorSet, setSelectedColorSet] = useState<EventColorSet | null>(null);

  const handleCardClick = useCallback((event: CalendarEvent, colorSet: EventColorSet) => {
    setSelectedEvent(event);
    setSelectedColorSet(colorSet);
  }, []);
  const isMobile = useMediaQuery({ maxWidth: Number.parseInt(medias.desktopSm, 10) - 1 });
  const agendaState = useAgendaMobile();

  const {
    setExecutoresSetoresModalOpen,
    setAmbientesEquipamentosModalOpen,
    setPlanosModalOpen,
    currentDate,
    view,
    viewsOptions,
    handleViewChange,
    goToToday,
    navigate,
    navigateByDay,
    weekDays,
    type,
    setType,
    planosSelectionLabel,
    executoresSetoresSelectionLabel,
    ambientesEquipamentosSelectionLabel,
    maintenanceUnitsOptions,
    maintenanceUnitsValues,
    handleMaintenanceUnitsChange,
    openFilters,
    setOpenFilters,
    hasActiveFilters,
    clearAllFilters,
    events,
    isLoadingEvents,
    fetchAgendaTasks,
    executoresSetoresModalOpen,
    ambientesEquipamentosModalOpen,
    planosModalOpen,
    executoresOptions,
    tempExecutoresValues,
    handleTempExecutoresChange,
    setoresOptions,
    tempSetoresValues,
    handleTempSetoresChange,
    applyExecutoresSetoresFilters,
    clearExecutoresSetoresFilters,
    onExecutoresSearch,
    areaGroupsOptions,
    areaSubgroupsOptions,
    areasOptions,
    equipmentTypesOptions,
    equipmentOptions,
    tempAreaGroupsValues,
    handleTempAreaGroupsChange,
    tempAreaSubgroupsValues,
    handleTempAreaSubgroupsChange,
    tempAreasValues,
    handleTempAreasChange,
    tempEquipmentTypesValues,
    handleTempEquipmentTypesChange,
    tempEquipmentValues,
    handleTempEquipmentChange,
    applyAmbientesEquipamentosFilters,
    clearAmbientesEquipamentosFilters,
    loadMoreAreas,
    searchArea,
    loadMoreEquipamentos,
    searchEquipamento,
    tempPlanosValues,
    handleTempPlanosChange,
    applyPlanosFilters,
    clearPlanosFilters,
    planosOptions,
  } = agendaState;

  return (
    <>
      <PageWrapper background={colors.pampas}>
        <MobileNavbar />

        <NewMenu setIsSubMenuOpen={setIsSubMenuOpen} />

        <HeaderFiltersPage monitoringPage={false} isSubMenuOpen={isSubMenuOpen}>
          <PageContent>
            <PageContentHeader>
              <Breadcrumbs />
              <KnowMoreLink
                href="https://leankeep.movidesk.com/kb/pt-br/article/575405/nova-agenda-web?ticketId=&q="
                target="_blank"
              >
                Saiba como usar a agenda
                <OpenIcon />
              </KnowMoreLink>
            </PageContentHeader>
            <AgendaContainer>
              {isMobile ? (
                <AgendaMobileLayout {...agendaState} onEventClick={handleCardClick} />
              ) : (
                <Calendar
                  setExecutoresSetoresModalOpen={setExecutoresSetoresModalOpen}
                  setAmbientesEquipamentosModalOpen={setAmbientesEquipamentosModalOpen}
                  setPlanosModalOpen={setPlanosModalOpen}
                  currentDate={currentDate}
                  view={view}
                  viewsOptions={viewsOptions}
                  handleViewChange={handleViewChange}
                  goToToday={goToToday}
                  navigate={navigate}
                  navigateByDay={navigateByDay}
                  weekDays={weekDays}
                  type={type}
                  setType={setType}
                  planosSelectionLabel={planosSelectionLabel}
                  executoresSetoresSelectionLabel={executoresSetoresSelectionLabel}
                  ambientesEquipamentosSelectionLabel={ambientesEquipamentosSelectionLabel}
                  maintenanceUnitsOptions={maintenanceUnitsOptions}
                  maintenanceUnitsValues={maintenanceUnitsValues}
                  onMaintenanceUnitsChange={handleMaintenanceUnitsChange}
                  openFilters={openFilters}
                  setOpenFilters={setOpenFilters}
                  hasActiveFilters={hasActiveFilters}
                  clearAllFilters={clearAllFilters}
                  events={events}
                  isLoadingEvents={isLoadingEvents}
                  fetchAgendaTasks={fetchAgendaTasks}
                  onCardClick={handleCardClick}
                />
              )}
            </AgendaContainer>
          </PageContent>
        </HeaderFiltersPage>
      </PageWrapper>
      {executoresSetoresModalOpen && (
        <FilterExecutorModal
          title={'Executores e Setores'}
          executoresFields={executoresOptions}
          setoresFields={setoresOptions}
          executoresValues={tempExecutoresValues}
          setoresValues={tempSetoresValues}
          onExecutoresChange={handleTempExecutoresChange}
          onSetoresChange={handleTempSetoresChange}
          onFilter={applyExecutoresSetoresFilters}
          onClearFilters={clearExecutoresSetoresFilters}
          onExecutoresSearch={onExecutoresSearch}
          setClose={(open: boolean) => {
            if (!open) {
              clearExecutoresSetoresFilters();
            }
          }}
        />
      )}
      {ambientesEquipamentosModalOpen && (
        <EnvironmentsEquipmentModal
          title={'Ambientes e Equipamentos'}
          areaGroupsOptions={areaGroupsOptions}
          areaSubgroupsOptions={areaSubgroupsOptions}
          areasOptions={areasOptions}
          equipmentTypesOptions={equipmentTypesOptions}
          equipmentOptions={equipmentOptions}
          areaGroupsValues={tempAreaGroupsValues}
          areaSubgroupsValues={tempAreaSubgroupsValues}
          areasValues={tempAreasValues}
          equipmentTypesValues={tempEquipmentTypesValues}
          equipmentValues={tempEquipmentValues}
          onAreaGroupsChange={handleTempAreaGroupsChange}
          onAreaSubgroupsChange={handleTempAreaSubgroupsChange}
          onAreasChange={handleTempAreasChange}
          onEquipmentTypesChange={handleTempEquipmentTypesChange}
          onEquipmentChange={handleTempEquipmentChange}
          onFilter={applyAmbientesEquipamentosFilters}
          onClearFilters={clearAmbientesEquipamentosFilters}
          onLoadMoreAreas={loadMoreAreas}
          onSearchArea={searchArea}
          onLoadMoreEquipamentos={loadMoreEquipamentos}
          onSearchEquipamento={searchEquipamento}
          setClose={(open: boolean) => {
            if (!open) {
              setAmbientesEquipamentosModalOpen(false);
            }
          }}
        />
      )}
      {planosModalOpen && (
        <PlanosModal
          title={'Planos'}
          planosOptions={planosOptions}
          planosValues={tempPlanosValues}
          onPlanosChange={handleTempPlanosChange}
          onFilter={applyPlanosFilters}
          onClearFilters={clearPlanosFilters}
          setClose={(open: boolean) => {
            if (!open) {
              setPlanosModalOpen(false);
            }
          }}
        />
      )}
      {selectedEvent && selectedColorSet && (
        <PlanApplicationModal
          event={selectedEvent}
          colorSet={selectedColorSet}
          isCompletedView={type === 'baixadas'}
          canEdit={true}
          canDelete={true}
          onClose={() => setSelectedEvent(null)}
          onEditProgramacao={() => setSelectedEvent(null)}
          onSaveSuccess={async () => {
            setSelectedEvent(null);
            await fetchAgendaTasks();
          }}
          onRestaurar={async () => {
            setSelectedEvent(null);
            await fetchAgendaTasks();
          }}
          onExcluir={async () => {
            setSelectedEvent(null);
            await fetchAgendaTasks();
          }}
        />
      )}
    </>
  );
};
